import { useNavigation } from '@refinedev/core';
import { List, useTable } from '@refinedev/antd';
import { Table, Button, Tag, Space, Avatar } from 'antd';
import { PlusOutlined, UserOutlined, EyeOutlined } from '@ant-design/icons';
import { usePermission } from '../../hooks/usePermission';
import { t } from '../../i18n';

interface Staff {
  id: number;
  username: string;
  fullName: string | null;
  phone: string | null;
  isActive: boolean;
  createdAt: string;
  lastLoginAt: string | null;
}

export const StaffList = () => {
  const { create, show } = useNavigation();
  const { can } = usePermission();

  const { tableProps } = useTable<Staff>({
    resource: 'admin/staff',
    syncWithLocation: true,
  });

  const columns = [
    {
      title: t('staff.title'),
      key: 'user',
      render: (_: unknown, record: Staff) => (
        <Space>
          <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#1ABC9C' }} />
          <div>
            <div>{record.fullName || record.username}</div>
            <div style={{ color: '#7F8C8D', fontSize: 12 }}>{record.username}</div>
          </div>
        </Space>
      ),
    },
    {
      title: t('staff.phone'),
      dataIndex: 'phone',
      key: 'phone',
      render: (phone: string | null) => phone || '-',
    },
    {
      title: t('staff.activeStatus'),
      dataIndex: 'isActive',
      key: 'isActive',
      render: (active: boolean) => (
        <Tag color={active ? 'green' : 'default'}>
          {active ? t('common.active') : t('common.inactive')}
        </Tag>
      ),
    },
    {
      title: t('staff.lastLogin'),
      dataIndex: 'lastLoginAt',
      key: 'lastLoginAt',
      render: (date: string | null) =>
        date ? new Date(date).toLocaleString('uz-UZ') : '-',
    },
    {
      title: t('common.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date: string) => new Date(date).toLocaleDateString('uz-UZ'),
    },
    {
      title: t('common.actions'),
      key: 'actions',
      render: (_: unknown, record: Staff) => (
        <Button
          type="text"
          icon={<EyeOutlined />}
          onClick={() => show('admin/staff', record.id)}
        />
      ),
    },
  ];

  return (
    <List
      title={t('staff.title')}
      headerButtons={
        can('staff', 'create') ? (
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => create('admin/staff')}
          >
            {t('staff.newStaff')}
          </Button>
        ) : null
      }
    >
      <Table {...tableProps} columns={columns} rowKey="id" />
    </List>
  );
};
